import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useLesson(stepId) {
  const [lesson, setLesson] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.steps.session.show(stepId))
      .then((response) => {
        setLesson(response.data.data);
      });
  }, []);

  return lesson;
}
